import * as React from 'react';
import { Row, Col, Space } from 'antd';
import { blueColor } from '@config/index';

import './index.less';

type NiFormProps = React.HTMLAttributes<{}> & {
  items: (NiFormItem | undefined)[];
  direction?: 'horizontal' | 'vertical';
  titleline?: boolean;
  hideTitleForSingle?: boolean;
  onPressEnter?: (e: any) => void;
};

export type NiFormItem = {
  key: string;
  label: string | React.ReactNode;
  content?: string | React.ReactNode;
  labelExtra?: string | React.ReactNode;
  extra?: string | React.ReactNode;
  labelTopPadding?: number | string;
  required?: boolean;
};

export class NiForm extends React.Component<NiFormProps> {

  handleKeyDown = (e: any) => {
    if (e.key === 'Enter' && this.props.onPressEnter) {
      // 回车键按下时，调用 onOk 方法
      this.props.onPressEnter(e);
    }
  };

  render() {

    const { direction = 'horizontal', titleline: titleLine = false, hideTitleForSingle, items } = this.props;

    const propsPayload = {
      ...this.props
    };

    delete propsPayload.titleline;

    return <div {...propsPayload} className={'ni-form ' + this.props.className || ''} onKeyDown={this.handleKeyDown}>
      {hideTitleForSingle
        ? this.getSingleContent()
        : this.props.items.map((item: NiFormItem | undefined) => {

          if (!item) {
            return '';
          }

          return direction === 'horizontal'
            ? <Row key={item.key} justify="start" className={`ni-form-item ${item.required ? 'required' : ''}`}>
              <Col className="ni-form-item-label" key="label" span={3}
                {...item.labelTopPadding && {
                  style: {
                    paddingTop: item.labelTopPadding
                  }
                }}
              >
                {
                  item.label
                }
              </Col>
              <Col className="ni-form-item-extra" key="extra" span={1}>
                {
                  item.labelExtra
                }
              </Col>
              <Col className="ni-form-item-content" key="content" span={20}>
                {typeof item.content === 'string' ?
                  <span>{item.content}</span>
                  : item.content
                }
              </Col>
            </Row>
            : <Col key={item.key} className={`ni-form-item ${item.required ? 'required' : ''}`} >
              <Row align="middle" gutter={8} style={{ height: 32 }}>
                {titleLine &&
                  < Col >
                    <div style={{ width: 3, height: 16, backgroundColor: blueColor }} />
                  </Col>
                }
                <Col className="ni-form-item-label" key="label"
                  {...item.labelTopPadding && {
                    style: {
                      paddingTop: item.labelTopPadding
                    }
                  }}
                >
                  {
                    item.label
                  }
                </Col>
                <Col className="ni-form-item-extra" key="extra" style={{ marginLeft: 4 }}>
                  {
                    item.labelExtra
                  }
                </Col>

                {item.extra &&
                  <Col className="ni-form-row-extra" flex={1}>
                    {
                      item.extra
                    }
                  </Col>
                }
              </Row>
              {
                <div style={{ marginTop: 4, flex: 1 }}>
                  {typeof item.content === 'string' ?
                    <span>{item.content}</span>
                    : item.content
                  }
                </div>
              }
            </Col >;
        })
      }
    </div >;
  }

  getSingleContent = () => {

    const { items } = this.props;
    const filtered = items.filter(Boolean);

    return (filtered && filtered.length && filtered[0] && filtered[0].content);

  }
}
